import { EventTypes } from 'redux-segment';

import { CURRENT_SALON_RESET } from 'lib/constants/currentSalon';

const feResetCurrentSalon = () => ({ type: CURRENT_SALON_RESET, meta: { analytics: EventTypes.track } });

// noinspection JSUnusedGlobalSymbols
export default feResetCurrentSalon;
